/**
 * @Builder By ShaJiaJing
 * @Date : 2019/5/28
 * @Version : 1.0
 * @Content : 权限配置
 * @Changed By ZhuYongFang
 * @Content : OAuth2授权配置
 */
let baseOAuthUrl
let ownUrl
let curClientId
let clientSecret
const env = process.env.VUE_APP_CURRENTMODE
// console.log(env)
if (env === 'development') {
  baseOAuthUrl = 'https://192.168.0.13/'
  ownUrl = 'http://127.0.0.1:9555/'
  curClientId = 'console10002'
  clientSecret = 'clientSecret'
} else if (env === 'testing') {
  // 测试
  baseOAuthUrl = 'https://192.168.0.13/'
  ownUrl = 'https://192.168.0.14/console/'
  curClientId = 'console10001'
  clientSecret = 'clientSecret'
} else if (env === 'uat') {
  // UAT
  baseOAuthUrl = 'https://account.i-search.com.cn:1443/'
  ownUrl = 'https://rpa.i-search.com.cn/console/'
  curClientId = 'console10001'
  clientSecret = 'clientSecret'
} else {
  // 正式
  baseOAuthUrl = 'https://account.i-search.com.cn/'
  ownUrl = 'https://rpa.i-search.com.cn/console/'
  curClientId = 'console10001'
  clientSecret = 'clientSecret'
}

// OAuth客户端配置
const config = {
  // baseOAuthUrl: 'https://github.com/',
  // 登录测试服务地址：https://192.168.0.13/
  baseOAuthUrl: baseOAuthUrl,
  // 请求授权地址
  // userAuthorizationUri: 'https://github.com/login/oauth/authorize',
  userAuthorizationUri: `${baseOAuthUrl}oauth/authorize`,
  // accessToken请求地址
  // accessTokenUri: '/github/login/oauth/access_token',
  accessTokenUri: `${baseOAuthUrl}oauth/token`,
  // 用户信息请求地址
  userInfoUri: `${baseOAuthUrl}v1/user`,
  // 退出请求地址
  logoutUri: `${baseOAuthUrl}oauth/logout`,
  // logoutUri: `${baseOAuthUrl}v1/logout`,
  // 检查token的请求地址
  checkToken_url: `${baseOAuthUrl}oauth/check_token`,
  // 控制台项目地址（地址需要在数据库中配置）
  // 测试服务地址：http://192.168.0.14:9529/
  localuri: ownUrl,
  redirect_uri: `${ownUrl}user/gittoken`,
  redirecttoken_uri: `${ownUrl}user/gittoken`,
  // 案例资源服务器地址（暂无使用）
  // resUri: 'http://192.168.0.14:9529',
  // 客户端相关标识，请从认证服务器申请
  // clientId: 'b71826d0caaa4746682c',
  // client_secret: 'b3fb7dd89494d5f83e8ae97173db8af931b7d69a',
  clientId: curClientId,
  client_secret: clientSecret,
  // 申请的权限范围
  // scope:'read_user',
  scope: 'select',
  // 可选参数，客户端的当前状态，可以指定任意值，用于校验，此次案例不做相关认证
  state: '',
  // 一些固定的请求参数
  // response_type:'token',
  response_type: 'code',
  grant_type: 'authorization_code',
  code: ''
}
export default config
